import React, { useEffect, useRef, useState } from "react";
import FileUpload from "../../../shared/FileUploader/FileUpload";
import AddIcon from "@mui/icons-material/Add";
import ProductInfoModal from "./ProductInfoModal";
import SidebarDetails from "../../../shared/scripts/SidebarDetails/SidebarDetails";
import { Button, Typography } from "@mui/material";

import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";
import { useNavigate, useParams } from "react-router-dom";
import fetchWithAuth from "../../../util/fetchWithAuth";
import { API_URL } from "../../../util/url";

function CrossDetail(props) {
  const modalRef = useRef(null);
  const [modalType, setModalType] = useState(null);
  const [selectedAttrIndex, setSelectedAttrIndex] = useState(null);
  const [file, setFile] = useState(null);
  const [quantity, setQuantity] = useState(0);
  const [title, setTitle] = useState("");
  const [info, setInfo] = useState("");
  const [attributes, setAttributes] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const navigate = useNavigate();

  const { scriptId } = useParams();
  const {
    data: scriptDetailsData,
    error,
    loading,
    refetch,
  } = useFetchWithAuth(`/scripts/cross-products/${scriptId}`, {
    method: "GET",
  });

  console.log(scriptDetailsData, "cross-products");
  const onFileSelect = (file) => setFile(file);
  const handleOpenModal = (type) => setModalType(type);
  const handleCloseModal = () => setModalType(null);

  const onConfirm = async () => {
    try {
      // Формируем payload с измененными полями
      const payload = {};

      // добавляем поля только если они не пустые
      if (quantity) payload.quantity = quantity;
      if (title) payload.title = title;
      if (file) payload.image = file;

      console.log(payload);
      const response = await fetchWithAuth(
        `${API_URL}/scripts/cross-products/${scriptId}/`,
        {
          method: "PATCH",
          body: payload,
        }
      );

      navigate("/supervisor/scripts/");
      if (!response.ok) throw new Error("Failed to update product");

      console.log("Product updated successfully");
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    setTitle(scriptDetailsData?.title);
    setQuantity(scriptDetailsData?.quantity);
  }, [scriptDetailsData]);
  return (
    <>
      <SidebarDetails
        id={scriptDetailsData?.cross_id}
        title={title}
        price={scriptDetailsData?.price}
        productName={title}
        imageComponent={<FileUpload onFileSelect={onFileSelect} />}
        bannerActions={
          <>
            <Button
              variant="outlined"
              sx={{ borderRadius: "25px", p: 1, height: "35px", width: "45px" }}
              onClick={() => handleOpenModal("title")}
            >
              <AddIcon />
            </Button>

            <Button
              variant="contained"
              className="btn btn-primary"
              sx={{ textTransform: "none" }}
              onClick={onConfirm}
            >
              <Typography variant="subtitle1"> Підтвердити</Typography>
            </Button>
          </>
        }
        actionComponent={
          <>
            <Button variant="text" onClick={() => handleOpenModal("quantity")}>
              + Кількість
            </Button>
          </>
        }
      />

      <ProductInfoModal
        open={Boolean(modalType)}
        onClose={handleCloseModal}
        modalType={modalType}
        modalRef={modalRef}
        setModalType={setModalType}
        setTitle={setTitle}
        title={title}
        quantity={quantity}
        setQuantity={setQuantity}
      />
    </>
  );
}

export default CrossDetail;
